export default __webpack_public_path__ + "images/tap2.e07fbda8bbf6b445c93ea461daeb3ee8.png";